export const EXPERIMENTS = {
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
  SHOW_DEMO_FORM: 'specs.forms.ShowDemoForm',
  ENABLE_PRESET_TAB: 'specs.forms.EnablePresetTab',
  BUTTON_TEXT_FORMATTING: 'specs.forms.SettingsButtonTextFormatting',
  WIX_SERVICES_INSTALLATION: 'specs.forms.WixServicesInstallation',
};
